var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 회사/사업장/세부사업장 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState } from "../../../recoil/menuState";
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP 사업장 전기실 관리 - 회사/사업장 컴포넌트 , 반응형 동작
 * @param -
 * @returns react components
 */
//component
function ZoneView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const workMode = props.workMode;
    const curTree = props.curTree;
    const setParentIsMobile = props.setIsMobile;
    const setParentAdminType = props.setAdminType;
    const setParentWorkMode = props.setWorkMode;
    const setParentPopWin = props.setPopWin;
    //
    const [zoneInfo, setZoneInfo] = useState(null);
    //화면 이동
    const navigate = useNavigate();
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    ////////////////////////////////////////////////////////////////////////////
    const { data: retCompany, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/${curTree.company.companyId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: curTree.company.companyId
    });
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retCompany);
        //clog("IN ZONEVIEW :  > " + isLoading + " : " + JSON.stringify(retCompany));
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retCompany) {
            setRecoilIsLoadinBox(true);
            //clog("IN ZONEVIEW : RES : " + JSON.stringify(retCompany));
            if (retCompany.codeNum == CONST.API_200) {
                (() => __awaiter(this, void 0, void 0, function* () {
                    const retZone = yield HTTPUTIL.PromiseHttp({
                        "httpMethod": "GET",
                        "appPath": `/api/v2/product/company/zone/detail`,
                        "appQuery": { zoneId: curTree.zone.zoneId },
                        "userToken": userInfo.loginInfo.token,
                        watch: curTree.zone.zoneId
                    });
                    setRecoilIsLoadinBox(false);
                    if (retZone.codeNum === CONST.API_200) {
                        (workMode === "INSREAD")
                            ? setParentPopWin("pop-area-right", // 인서트 후 조회용
                            React.createElement(MobileZoneView, { htmlHeader: React.createElement("h1", null, "\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"), zoneInfo: { company: retCompany.body, zone: retZone.body }, onClickSubZoneInsert: onClickSubZoneInsert }))
                            : setParentPopWin("pop-area-right-page-info", React.createElement(MobileZoneView, { zoneInfo: { company: retCompany.body, zone: retZone.body }, onClickSubZoneInsert: onClickSubZoneInsert }));
                        setZoneInfo({ company: retCompany.body, zone: retZone.body });
                    }
                    else {
                        setZoneInfo(null);
                    }
                }))();
            }
            setRecoilIsLoadinBox(false);
        }
    }, [curTree, retCompany]);
    // 상세사업장 추가
    function onClickSubZoneInsert(e) {
        e.stopPropagation();
        clog("IN SUBZONETREE : onClickSubZoneInsert : " + e.target.tagName);
        setParentAdminType("SUBZONE");
        setParentWorkMode("CREATE");
        CUTIL.jsopen_s_Popup(e, isMobile);
    }
    //clog("IN ZONEVIEW : ZONEINFO : " + JSON.stringify(zoneInfo));
    return (React.createElement(React.Fragment, null, (zoneInfo) &&
        React.createElement("div", { ref: mobileRef, className: "area__right" },
            React.createElement("ul", { className: "page-loca" },
                React.createElement("li", null, zoneInfo.company.companyName),
                React.createElement("li", null, zoneInfo.zone.zoneName)),
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null,
                    zoneInfo.company.companyName,
                    " ",
                    zoneInfo.zone.zoneName)),
            React.createElement("div", { className: "area__right_content workplace__info workplace__main" },
                React.createElement("div", { className: "content__info" },
                    React.createElement("h3", { className: "hide" }, "\uC0AC\uC5C5\uC7A5 \uC815\uBCF4"),
                    React.createElement("div", { className: "img_workplace" }, ((zoneInfo.zone.imageDto) && (zoneInfo.zone.imageDto.url) && (zoneInfo.zone.imageDto.url.length > 0))
                        ? React.createElement("img", { src: zoneInfo.zone.imageDto.url, alt: "\uC0AC\uC9C4\uC601\uC5ED" })
                        : React.createElement("img", { src: require("/static/img/img_workplace/bg_add.jpg"), alt: "\uC0AC\uC9C4\uC601\uC5ED" })),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uD68C\uC0AC \uBA85"),
                            React.createElement("p", { className: "txt" }, zoneInfo.company.companyName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                            React.createElement("p", { className: "txt" }, zoneInfo.zone.zoneName)),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                            React.createElement("p", { className: "txt" }, (zoneInfo.zone.hasOwnProperty("address")) ? zoneInfo.zone.address : "-")),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                            React.createElement("p", { className: "txt" }, zoneInfo.zone.memo)))),
                React.createElement("div", { className: "content__list scrollH" },
                    React.createElement("div", { className: "listbox__top" },
                        React.createElement("h3", null, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D"),
                        React.createElement("button", { type: "button", className: "add__item", onClick: (e) => onClickSubZoneInsert(e), "data-pop": "pop-area-right-page-info" },
                            React.createElement("span", null, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"))),
                    React.createElement("div", { className: "listbox__area" }, zoneInfo.zone.subZoneManageList.map((subZone, idx) => (React.createElement("div", { key: `szone_${idx.toString()}`, className: "listbox" },
                        React.createElement("div", { className: "box__top" },
                            React.createElement("p", { className: "factory" }, subZone.subZoneName)),
                        React.createElement("ul", { className: "box__bottom" },
                            React.createElement("li", null,
                                React.createElement("div", null,
                                    React.createElement("p", null,
                                        React.createElement("span", null, "\uB4F1\uB85D \uC124\uBE44 \uC218"),
                                        React.createElement("strong", null, subZone.itemCount))))))))))))));
}
;
export default ZoneView;
function MobileZoneView(props) {
    //props
    const zoneInfo = props.zoneInfo;
    const onClickSubZoneInsert = props.onClickSubZoneInsert;
    return (React.createElement(React.Fragment, null, (zoneInfo) &&
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "popup__body" },
                React.createElement("ul", { className: "page-loca" },
                    React.createElement("li", null, zoneInfo.company.companyName),
                    React.createElement("li", null, zoneInfo.zone.zoneName)),
                React.createElement("div", { className: "page-top" },
                    React.createElement("h2", null,
                        zoneInfo.company.companyName,
                        " ",
                        zoneInfo.zone.zoneName)),
                React.createElement("div", { className: "area__right_content workplace__info workplace__main" },
                    React.createElement("div", { className: "content__info" },
                        React.createElement("h3", { className: "hide" }, "\uC0AC\uC5C5\uC7A5 \uC815\uBCF4"),
                        React.createElement("div", { className: "img_workplace" },
                            React.createElement("img", { 
                                /* src={
                                  (zoneInfo.zone.hasOwnProperty("imageDto"))
                                    ? (zoneInfo.zone.imageDto)
                                      ? zoneInfo.zone.imageDto.url
                                      : "#"
                                    : "#"
                                } */
                                /* 20221018 수정 */
                                src: (zoneInfo.zone.hasOwnProperty("imageDto"))
                                    ? (zoneInfo.zone.imageDto)
                                        ? zoneInfo.zone.imageDto.url
                                        : require("/static/img/img_workplace/bg_add.jpg")
                                    : require("/static/img/img_workplace/bg_add.jpg"), alt: "" })),
                        React.createElement("ul", null,
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uD68C\uC0AC \uBA85"),
                                React.createElement("p", { className: "txt" }, zoneInfo.company.companyName)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uBA85"),
                                React.createElement("p", { className: "txt" }, zoneInfo.zone.zoneName)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC7A5 \uC8FC\uC18C"),
                                React.createElement("p", { className: "txt" }, (zoneInfo.zone.hasOwnProperty("address")) ? zoneInfo.zone.address : "-")),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                                React.createElement("p", { className: "txt" }, zoneInfo.zone.memo))),
                        React.createElement("ul", { className: "info__admin" },
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uD68C\uC0AC URL"),
                                React.createElement("p", { className: "txt" },
                                    React.createElement("a", { href: (zoneInfo.company.hasOwnProperty("url")) ? zoneInfo.company.url : "#", target: "_blank" }, (zoneInfo.company.hasOwnProperty("url")) ? zoneInfo.company.url : "--"))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638"),
                                React.createElement("p", { className: "txt" }, zoneInfo.company.businessNo)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" },
                                    "\uAD00\uB9AC\uC790",
                                    React.createElement("span", null, "(Business Admin)")),
                                React.createElement("p", { className: "txt" }, zoneInfo.company.administrator)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uC5C5\uC885/\uC5C5\uD0DC"),
                                React.createElement("p", { className: "txt" }, zoneInfo.company.classification)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9"),
                                React.createElement("p", { className: "txt" }, zoneInfo.company.accountManager)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" },
                                    "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9",
                                    React.createElement("span", null, "(Tel)")),
                                React.createElement("p", { className: "txt" }, zoneInfo.company.accMngrTelephone)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "I/F Info"),
                                React.createElement("p", { className: "txt" }, zoneInfo.company.interfaceInfo)),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                                React.createElement("p", { className: "txt" }, zoneInfo.company.memo)))),
                    React.createElement("div", { className: "content__list scrollH" },
                        React.createElement("div", { className: "listbox__top" },
                            React.createElement("h3", null, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uBAA9\uB85D"),
                            React.createElement("button", { type: "button", className: "add__item", onClick: (e) => onClickSubZoneInsert(e), "data-pop": "pop-area-right-page-info" },
                                React.createElement("span", null, "\uC0C1\uC138\uC0AC\uC5C5\uC7A5 \uCD94\uAC00"))),
                        React.createElement("div", { className: "listbox__area" }, zoneInfo.zone.subZoneManageList.map((subZone, idx) => (React.createElement("div", { key: `szone_${idx.toString()}`, className: "listbox" },
                            React.createElement("div", { className: "box__top" },
                                React.createElement("p", { className: "factory" }, subZone.subZoneName)),
                            React.createElement("ul", { className: "box__bottom" },
                                React.createElement("li", null,
                                    React.createElement("div", null,
                                        React.createElement("p", null,
                                            React.createElement("span", null, "\uB4F1\uB85D \uC124\uBE44 \uC218"),
                                            React.createElement("strong", null, subZone.itemCount)))))))))))))));
}
